import { IPProgressIndicator } from 'baseComponents';

//A line box that contains only an inline-block gets no strut, which would collapse the row to the
//height of the bar. This zero-width space keeps the row as tall as the text the bar replaces.
const lineBoxStrut = '\u200b';

interface ILoadingProgressBarProps {
  barHeight?: number;
}

//Indeterminate progress bar for inline loading states.
//Stays inline-level on purpose: it replaces text inside a line box, so the row keeps the height it
//has when the text is there and the surrounding layout does not shift while loading.
export const LoadingProgressBar = (props: ILoadingProgressBarProps) => {
  const barHeight = props.barHeight ?? 6;

  return (
    <>
      <span style={{ display: 'inline-block', width: '100%', verticalAlign: 'middle' }}>
        <IPProgressIndicator
          barHeight={barHeight}
          styles={{
            //Fluent pads itemProgress with 8px top and bottom by default, which would make the bar
            //16px taller than barHeight and push the content below it down.
            itemProgress: {
              padding: 0,
              borderRadius: barHeight / 2,
            },
            //Fluent paints the indeterminate bar with a single theme colour, so the gradient has to
            //replace the background shorthand. The transparent end stops keep the soft fade of the
            //built-in bar and let the themed track show through in both light and dark mode.
            progressBar: {
              background:
                'linear-gradient(to right, transparent 0%, #0078d4 22%, #8378de 50%, #d83b95 78%, transparent 100%)',
            },
          }}
        />
      </span>
      {lineBoxStrut}
    </>
  );
};
